import {
  AddConsultantEventLogMailMutationVariables,
  GetPersonalInfoCardData,
  useAddConsultantEventLogMailMutation
} from "@bonliva-crm/graphql";
import { HookProps } from "../utils/hook-props";

export function useAddConsultantEventLogMail(props: HookProps) {
  const [addConsultantEventLogMailMutation] = useAddConsultantEventLogMailMutation({
    onError: (error) => {
      console.error(error);
      props.onError && props.onError(error);
    },
    onCompleted: () => {
      props.onCompleted && props.onCompleted();
    }
  });

  const addConsultantEventLogMail = (
    args: AddConsultantEventLogMailMutationVariables
  ) => {
    props.onBeforeCall && props.onBeforeCall();
    addConsultantEventLogMailMutation({
      variables: args,
      refetchQueries: [GetPersonalInfoCardData.OperationName]
    });
  };

  return { addConsultantEventLogMail };
}
